
import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import SlidingModal from "../../../CustomModal/SlidingModal";
import { useState } from "react";
import Loader from "../../../Common/loader";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import "../../../AttackSurface/common.scss";
import "../mspMembersAccess.scss"
import { getAPIData, postData, postJsonData, postRequest } from "../../../../Utils/commonApi";
import { useAuth } from "../../../context/Auth";
import AccessItem from "../../Components/AccessItem";
import AssignedUsersBlock from "./AssignedUsersBlock";
import { AccessRoleModulesName, AccessStatesName } from "../../../../constants/access-roles.constants";
import { InputItem } from "../../Components/MspAccessLevelModal";
import { API_DOMENS } from "../../../../constants/apis.constants";

const MspMemberAccessRoleModal = ({ show, hideModal, parentID, accessLevelId, refreshData, passedOptionEnum99, dontAllowEdit = false, setUsersInUseData }) => {
  const { authTokens } = useAuth();
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [saving, setSaving] = useState(false);
  const [adding, setAdding] = useState(false);
  const [accessSettings, setAccessSettings] = useState([]);
  const [moduleGroups, setModuleGroups] = useState([]);
  const [role, setRole] = useState({});
  const [users, setUsers] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedMembersList, setSelectedMembersList] = useState([]);

  useEffect(() => {
    if (show) {
      setLoading(true);
      getAccessSettings();
      getMembersDetails();
    }
  }, [show]);

  async function getAccessSettings() {
    await getAPIData("562", authTokens, passedOptionEnum99 ? {
      optionEnum1: accessLevelId ? accessLevelId : 0,
      optionEnum99: passedOptionEnum99
    } : {
      optionEnum1: accessLevelId ? accessLevelId : 0
    }, API_DOMENS.CC_API).then((response) => {
      if (response.mr.Success) {
        setRole(response.data?.role);
        setAccessSettings(response.data?.permissions?.filter((item) => item?.moduleName != "Technical Drilldown" && item?.moduleName != "Cyber Trend Data" && item?.moduleName != "Pro Services"
          && item?.moduleName != "MSP Attack Surface Insights" && item?.moduleName != "Logs" && item?.moduleGroup != 'Marketing'));
        let permissions = response.data?.permissions?.filter((item) => item?.moduleGroup != 'Marketing')?.map((set) => {
          return set.moduleGroup;
        });
        let tempGroup = [...new Set(permissions)];
        setModuleGroups(tempGroup);
        setUsers(response.data?.existingUsers);
        setLoading(false);
      }
    });
  }

  function changeAccessDropdown(obj, id) {
    let newSettings = accessSettings.map(setting => {
      if (setting.objId_Module == id) {
        setting.selected_AccessState = obj;
        setting.error = undefined;
      }
      return setting;
    });
    setAccessSettings(newSettings);
  }

  async function deleteAccessLevel() {
    setDeleting(true);
    await postRequest(authTokens, "DeleteAccessRole", passedOptionEnum99 ? {
      objId_AccessRole: accessLevelId,
      optionEnum99: passedOptionEnum99,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
    } : {
      objId_AccessRole: accessLevelId
    }
    , API_DOMENS.CC_API)
      .then((response) => {
        setDeleting(false);
        if (response?.Success) {
          CallToast("Access role deleted successfully", false, false, "v2style");

          hideModal();
          if (refreshData) {
            refreshData();
          }
        } else {
          setUsersInUseData(response?.detail);
        }
      })
      .catch(() => {
        CallToast("Something went wrong", false, false, "v2style");
      });
  }

  const validateAccessObject = (accessObject) => {
    if (!accessObject?.role?.RoleName || accessObject?.role?.RoleName.trim() === "") {
      return {
        accessSettings: accessObject?.permissions,
        hasErrors: true,
        errorToast: "Access role name cannot be empty"
      }
    }
    let hasErrors = false;
    const updatedAccessSettings = accessObject?.permissions.map((item) => {
      const isDashboardModule = item?.moduleName === AccessRoleModulesName.Dashboard;
      if (!isDashboardModule) return item;
      let error = undefined;
      if (!item?.selected_AccessState) {
        error = "Invalid access state";
        hasErrors = true;
      }
      const noAccessStateObject = item?.accessStates.find((state) => state.stateName === AccessStatesName.NoAccess);
      if (noAccessStateObject && item?.selected_AccessState?.objId_MSPAccessMapping === noAccessStateObject.objId_MSPAccessMapping) {
        error = "Invalid access state";
        hasErrors = true;
      }
      return {
        ...item,
        error
      };
    });
    const firstErrorItem = updatedAccessSettings.find((item) => item.error);
    return {
      accessSettings: updatedAccessSettings,
      hasErrors,
      errorToast: hasErrors && firstErrorItem?.error ? firstErrorItem.error : undefined
    };
  }

  async function sendRequest(newAccess) {
    setSaving(true);
    let accessObject = {
      role: role,
      permissions: accessSettings,
      existingUsers: users
    };
    const { hasErrors, accessSettings: updatedAccessSettings, errorToast } = validateAccessObject(accessObject);
    setAccessSettings(updatedAccessSettings);
    if (!hasErrors) {
      await postJsonData(authTokens, "UpsertAccessRole",
        accessObject
      , API_DOMENS.CC_API)
        .then((response) => {
          setSaving(false);
          if (response?.Success) {
            CallToast("Access role updated successfully", false, false, "v2style");

            hideModal();
            if (refreshData) {
              refreshData();
            }
          } else {
            CallToast(response.Message, false, false, "v2style");
          }
        })
        .catch(() => {
          CallToast("Something went wrong", false, false, "v2style");
        });
    }
    else {
      if (errorToast) {
        CallToast(errorToast, false, false, "v2style");
      } else {
        const topError = updatedAccessSettings.find((setting) => setting.error);
        const moduleId = `module-${topError.objId_Module}`;
        const element = document.getElementById(moduleId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      setSaving(false);
    }
  }

  async function getMembersDetails(openTeamModal = null) {
    await getAPIData(passedOptionEnum99 === 5 ? "563" : "564", authTokens, passedOptionEnum99 === 5 ? {
      optionEnum1: "1",
      optionEnum2: "100",
      optionEnum3: "1",
      optionEnum99: passedOptionEnum99
    } : passedOptionEnum99 ? {
      optionEnum1: 0,
      optionEnum99: passedOptionEnum99
    } : {
      optionEnum1: 0,
    }, API_DOMENS.CC_API).then((response) => {
      if (response.mr.Success) {
        setMembers(response?.users);
      } else {
        CallToast("Something went wrong", false, false, "v2style");
      }
    });
  }

  async function inviteMember() {
    setAdding(true);
    let list = [];
    selectedMembersList.map(member => {
      list.push({ Key: member.objId_PSAMember, Value: member.userName });
    })
    await postData(authTokens, "Invite_MSPTeamMember", passedOptionEnum99 ? {
      objId_AccessRole: role?.objId_AccessRole,
      obj_List: JSON.stringify(list),
      optionEnum99: passedOptionEnum99
    } : {
      objId_AccessRole: role?.objId_AccessRole,
      obj_List: JSON.stringify(list),
    }
    , API_DOMENS.CC_API)
      .then((response) => {
        setAdding(false);
        if (response?.Success) {
          CallToast("Member invited successfully", false, false, "v2style");

          hideModal();
          if (refreshData) {
            refreshData();
          }
        } else {
          CallToast("Something went wrong", false, false, "v2style");
        }
      })
      .catch(() => {
        CallToast("Something went wrong", false, false, "v2style");
      });
  }

  return (
    <SlidingModal
      show={show}
      className="common-big-modal memberAccessModal"
      parentID={parentID}
      id="ounsqxw"
      onHide={hideModal}
    >
      <SlidingModal.Header className="text-center d-flex p-3 border-bottom">
        <div
          className="w-100 mb-0 font-bold-14 title"
          style={{ fontWeight: "600" }}
        >
          {accessLevelId > 0 ? role?.RoleName : 'Add Access Role'}
        </div>

        <span className="cursor-pointer" onClick={hideModal}>
          <img src="/images/attack-surface/cross-icon.svg" alt="" />
        </span>
      </SlidingModal.Header>
      <SlidingModal.Body className={`msp-service-add-edit-modal    ${true}`}>
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center w-100 "
            style={{
              height: "85vh",
            }}
          >
            <Loader />
          </div>
        ) : (
          <div className="m-24px">
            <InputItem
              isDisable={dontAllowEdit}
              placeholder={'Name: Type'}
              value={role?.RoleName}
              onChange={(value) => { setRole({ ...role, RoleName: value }) }}
            />
            <InputItem
              isDisable={dontAllowEdit}
              placeholder={'Description: Type'}
              value={role?.RoleDescription}
              onChange={(value) => { setRole({ ...role, RoleDescription: value }) }}
            />

            <AssignedUsersBlock
              data={users}
              members={members}
              selectedMembers={selectedMembersList}
              dontAllowEdit={dontAllowEdit}
              adding={adding}
              passedOptionEnum99={passedOptionEnum99}
              inviteMember={inviteMember}
              getMembersDetails={getMembersDetails}
              onItemClick={(val) => {
                const mergedArray = [...selectedMembersList];
                for (let obj of val) {
                  const existingObj = mergedArray.find(item => item.objId_PSAMember === obj.objId_PSAMember);
                  if (!existingObj) {
                    mergedArray.push(obj);
                  }
                }
                setSelectedMembersList(val);
              }}
            />

            <div className="border-top mt-24px">
              {moduleGroups.map((group, index) => {
                return (<>
                  <div className="f-12 f-darkgrey mt-16px" key={`${group} + ${index}`}>{group}</div>
                  {
                    accessSettings.map((setting, index) => {
                      if (setting.moduleGroup === group) {
                        return (
                          <AccessItem
                            key={`$module-${setting.objId_Module}`}
                            name={setting.moduleName}
                            description={setting.moduleDescription}
                            isComingSoon={setting.moduleName == "MSP Attack Surface Insights" || setting.moduleName == "Logs" || setting.moduleGroup == "Marketing"}
                            passedMarginBottom={setting.moduleGroup == "Marketing" && '5px'}
                            dontAllowEdit={dontAllowEdit}
                            options={setting.accessStates}
                            selectedOption={setting.selected_AccessState}
                            onSelectOption={(optionItem) => {
                              changeAccessDropdown(optionItem, setting.objId_Module);
                            }}
                          />
                        );
                      }

                    })
                  }
                </>);
              })
              }

            </div>
          </div>
        )}

      </SlidingModal.Body>
      <SlidingModal.Footer className="p-3 position-sticky w-100 border-top">
        <div className="d-flex align-items-center justify-content-between">
          {
            !dontAllowEdit ? <>
              <div>{accessLevelId > 0 && (
                <div className="d-flex align-items-center f-500 f-grey pointer" onClick={() => { deleteAccessLevel(); }}>
                  <img alt="" className="mx-2" src="/images/actioncenter/delete.svg" />
                  {deleting ? "Deleting..." : "Delete"}
                </div>
              )}
              </div>
            </> : <div className="w-100"></div>
          }

          <div className="d-flex justify-content-end">
            <Button className="hg-cancel-btn mr-2" onClick={hideModal}>
              Cancel
            </Button>
            {
              !dontAllowEdit &&
              <Button disabled={false} className="hg-blue-btn" onClick={() => { sendRequest() }}>
                {saving ? "Saving.." : "Save"}
              </Button>
            }
          </div>
        </div>
      </SlidingModal.Footer>
    </SlidingModal>
  );
};

export default MspMemberAccessRoleModal;
